import cn from "classnames";
import { Loader } from "../../../loader";
import { useInfiniteScroll } from "../../hooks/use-infinite-scroll";
import { TableInfiniteScrollProps } from "./types";
import styles from "./styles.module.scss";

export const TableInfiniteScroll = ({
  hasMore,
  className,
  isLoading,
  onLoadMore,
  dataTestId = "table-infinite-scroll",
}: TableInfiniteScrollProps) => {
  const { setScrollThreshold } = useInfiniteScroll({
    hasMore,
    onLoadMore,
  });

  if (!hasMore) {
    return null;
  }

  return (
    <div className={cn(styles.container, className)} data-test-id={dataTestId}>
      {isLoading ? (
        <Loader dataTestId={`${dataTestId}-loader`} />
      ) : (
        <div
          data-test-id={`${dataTestId}-threshold`}
          ref={setScrollThreshold}
        />
      )}
    </div>
  );
};
